import Modal from "react-modal";
import Contact from "../Contact";
import Social from "../Social";
import React from "react";
import { contact } from "../../config/site";

export const ContactModal = ({ isOpen, setIsOpen }) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={() => setIsOpen(false)}
    contentLabel="צור קשר"
    className="custom-modal"
    overlayClassName="custom-overlay"
    closeTimeoutMS={500}
  >
    <div className="shane_tm_mobalbox_contact">
      <button
        className="close-modal"
        onClick={() => setIsOpen(false)}
        aria-label="סגור"
      >
        <img src="/img/cancel.svg" alt="" />
      </button>
      <div className="box_inner">
        <div className="description_wrap scrollable">
          <div className="contact_modal_header">
            <h3>צור קשר</h3>
          </div>

          <div className="short_info">
            <ul>
              <li>
                <div className="list_inner">
                  <img className="svg" src="/img/location.svg" alt="" />
                  <span className="contact_label">כתובת</span>
                  <p>{contact.address}</p>
                </div>
              </li>
              <li>
                <div className="list_inner">
                  <img className="svg" src="/img/phone.svg" alt="" />
                  <span className="contact_label">טלפון</span>
                  <p>
                    {contact.phones.map((phone, i) => (
                      <React.Fragment key={phone.href}>
                        <a href={phone.href}>{phone.label}</a>
                        {i < contact.phones.length - 1 && <br />}
                      </React.Fragment>
                    ))}
                  </p>
                </div>
              </li>
              <li>
                <div className="list_inner">
                  <img className="svg" src="/img/message.svg" alt="" />
                  <span className="contact_label">דוא״ל</span>
                  <p>
                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                  </p>
                </div>
              </li>
              <li>
                <div className="list_inner">
                  <img className="svg" src="/img/share.svg" alt="" />
                  <span className="contact_label">רשתות חברתיות</span>
                  <Social />
                </div>
              </li>
            </ul>
          </div>

          <div className="wrapper">
            <div className="left">
              <h4>שליחת הודעה</h4>
              <p className="form_intro">
                השאירו פרטים ונחזור אליכם בהקדם, או פנו אלינו ישירות בטלפון.
              </p>
              <div className="fields">
                <Contact onSubmit={() => setIsOpen(false)} />
              </div>
            </div>
            <div className="right">
              <div className="map_panel">
                <div className="map_panel_label">מיקום המשרד</div>
                <iframe
                  title="מפת המשרד"
                  src={contact.mapEmbedUrl}
                  width="500"
                  height="360"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
);
